import { useLocalization } from './use-localization';

type BusinessVertical = 'B2C' | 'B2B';

type GenericEvent = {
    event: string;
    [key: string]: string | number;
};

export enum ConsumerApplicationProduct {
    CREDIT_CARD = 'Credit Card',
    DEPOSIT = 'Deposit',
}

type ConsumerApplicationInterface = GenericEvent & {
    ApplicationID?: string | number; // Add the ID generated when the user starts their application (if available)
    ProductVariant: string; // Add the exact type of the product e.g. Saving max
    StepName?: string; // Add what page the user is on e.g. 'g in', 'rsonal info page'
    StepNumber?: string | number; // Add which stage in the application process the user is, e.g. page 1
    BusinessVertical?: BusinessVertical;
};

export const useDataLayer = () => {
    const { getCountry } = useLocalization();

    function dataLayerPush(event: GenericEvent | GenericEvent[], businessVertical: BusinessVertical = 'B2C') {
        const DEFAULTS = {
            Market: getCountry().toUpperCase(),
            BusinessVertical: businessVertical,
        };

        const events = Array.isArray(event) ? event : [event];

        events.forEach(e => {
            const data = {
                ...DEFAULTS,
                ...e,
            };

            if (typeof window === 'undefined') {
                return;
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(data);
        });
    }

    function consumerApplicationFlowPush(event: ConsumerApplicationInterface, product: keyof typeof ConsumerApplicationProduct = 'CREDIT_CARD') {
        const DEFAULTS = {
            ApplicationID: '',
            StepName: '',
            StepNumber: '',
            Product: ConsumerApplicationProduct[product],
        };

        dataLayerPush({
            ...DEFAULTS,
            ...event,
        });
    }

    return {
        dataLayerPush,
        consumerApplicationFlowPush,
    };
};
